<template>
  <div>
    <report :clcki-name="clckiName" />
  </div>
</template>

<script>
// 获取接口地址
import Report from '../components/xxhd/qyjybg/report.vue'

export default {
  name: 'Qyjybg',
  components: {
    Report
    // sideMenu,
    // Header
  },
  data() {
    return {
      clckiName: '详情'
    }
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
